import { defineAction } from './types';

export default defineAction({
  action: 'CONNECT_CALENDAR',
  getHref: () => '/meetings?connect=true',
  getFollowUp: () => ({
    title: 'Connect your calendar',
    message:
      'Connect a Google or Outlook calendar. Afternoon will sync your meetings automatically.',
  }),
  completionEvents: ['CALENDAR_CONNECTED'],
});
